
function clearCache () {
window.sessionStorage.clear();
}

export {clearCache}


// WEBPACK FOOTER //
// ./src/util/sessionStorageController.js